import { render, staticRenderFns } from "./GlobalGame.vue?vue&type=template&id=6472b54c&scoped=true"
import script from "./GlobalGame.vue?vue&type=script&lang=js"
export * from "./GlobalGame.vue?vue&type=script&lang=js"
import style0 from "./GlobalGame.vue?vue&type=style&index=0&id=6472b54c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472b54c",
  null
  
)

export default component.exports